import { useQuery } from "react-query";
import { getAcquisitionNameList } from "../../../../../actions/Employees";

export const useGetAcquisitionName = () => {
  return useQuery("GetAcquisitionNames", getAcquisitionNameList, {
    refetchOnWindowFocus: false,
  });
};
